module.exports = __webpack_public_path__ + "img/level1_running_gun_shadow.03774496.png";